/* Mobile board: the row bleeds to the screen edges and scrolls sideways. */
.scroller {
  margin: 0 calc(-1 * var(--gutter));
  overflow-x: auto;
  scroll-snap-type: x proximity;
}

.row {
  display: flex;
  gap: 14px;
  width: max-content;
  padding: 4px var(--gutter) 16px;
}

.row > * {
  width: 300px;
  flex: none;
  scroll-snap-align: start;
  scroll-margin-left: var(--gutter);
}

@media (min-width: 1024px) {
  .scroller {
    margin: 0;
    overflow: visible;
  }

  .row {
    display: grid;
    /* Four across the full container, as CardGrid (section.module.css). */
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 20px;
    width: auto;
    padding: 0;
  }

  .row > * {
    width: auto;
  }
}
